import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface KidAdvancedActionsProps {
  kidId: number;
  isBusy: boolean;
  onAdd15: () => void;
  onRemoveAll: () => void;
  onCustomAdjust: (seconds: number) => void;
  onSetTarget: (seconds: number) => void;
}

export function KidAdvancedActions({
  kidId,
  isBusy,
  onAdd15,
  onRemoveAll,
  onCustomAdjust,
  onSetTarget,
}: KidAdvancedActionsProps) {
  const [customDelta, setCustomDelta] = useState("900");
  const [customTarget, setCustomTarget] = useState("0");

  return (
    <div className="grid gap-3 rounded-lg border border-dashed p-3">
      <div className="flex flex-wrap gap-2">
        <Button type="button" variant="secondary" className="min-h-11" disabled={isBusy} onClick={onAdd15}>
          +15m
        </Button>
        <Button type="button" variant="destructive" className="min-h-11" disabled={isBusy} onClick={onRemoveAll}>
          Remove all
        </Button>
      </div>

      <div className="grid gap-3 md:grid-cols-2">
        <div className="grid gap-2">
          <Label htmlFor={`kid-custom-adjust-${kidId}`}>Custom adjust seconds</Label>
          <div className="flex gap-2">
            <Input
              id={`kid-custom-adjust-${kidId}`}
              value={customDelta}
              onChange={event => setCustomDelta(event.currentTarget.value)}
              inputMode="numeric"
            />
            <Button
              type="button"
              variant="outline"
              className="min-h-11"
              disabled={isBusy}
              onClick={() => {
                const value = Number.parseInt(customDelta, 10);
                if (Number.isFinite(value)) {
                  onCustomAdjust(value);
                }
              }}
            >
              Apply
            </Button>
          </div>
        </div>

        <div className="grid gap-2">
          <Label htmlFor={`kid-set-target-${kidId}`}>Set target seconds</Label>
          <div className="flex gap-2">
            <Input
              id={`kid-set-target-${kidId}`}
              value={customTarget}
              onChange={event => setCustomTarget(event.currentTarget.value)}
              inputMode="numeric"
            />
            <Button
              type="button"
              variant="outline"
              className="min-h-11"
              disabled={isBusy}
              onClick={() => {
                const value = Number.parseInt(customTarget, 10);
                if (Number.isFinite(value)) {
                  onSetTarget(value);
                }
              }}
            >
              Apply
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
